import { Entity } from "../../../Entity";
import AgencySettingsFactory from "../../../Factories/AgencySettingsFactory";
import { FactoryInterface } from "../../../FactoryInterface";
import { AgencySettingsInterface } from "./AgencySettingsInterface";
import { LocaleInterface } from "../../Locale/LocaleInterface";
import { LanguageInterface } from "../../Language/LanguageInterface";

class AgencySettings extends Entity implements AgencySettingsInterface {

  constructor(public data) {
    super();
  }

  public getFactory(): FactoryInterface {
    return AgencySettingsFactory;
  }

  get defaultLocale(): LocaleInterface {
    return this.data.defaultLocale;
  }

  get defaultLanguage(): LanguageInterface {
    return this.data.defaultLanguage;
  }

  get defaultCalculation(): string {
    return this.data.defaultCalculation;
  }

  get financialStartDate(): Date {
    return this.data.financialStartDate;
  }

  get notificationPeriod(): number {
    return this.data.notificationPeriod;
  }

  get vatPercentage(): number {
    return this.data.vatPercentage;
  }

  get isBusy(): boolean {
    return this.data.isBusy;
  }

  get isActivitiesShown(): boolean {
    return this.data.isActivitiesShown;
  }

  get isActivateInvoiceNumber(): boolean {
    return this.data.isActivateInvoiceNumber;
  }

  get reviewOwnerStatements(): boolean {
    return this.data.reviewOwnerStatements;
  }

  get statementEmailTextEn(): string {
    return this.data.statementEmailTextEn;
  }

  get statementEmailTextNl(): string {
    return this.data.statementEmailTextNl;
  }
  get adjustRentEmailTextEN(): string {
    return this.data.adjustRentEmailTextEN;
  }

  get adjustRentEmailTextNL(): string {
    return this.data.adjustRentEmailTextNL;
  }
  
  get useAgencyNameForEmail(): boolean {
    return this.data.useAgencyNameForEmail;
  }

  get sendCopyToEmails(): string[] {
    return this.data.sendCopyToEmails;
  }

  get sendCopyToSubject(): string {
    return this.data.sendCopyToSubject;
  }
  get useAgencyAsSenderForAutoEmails(): boolean {
    return this.data.useAgencyAsSenderForAutoEmails;
  }
}

export { AgencySettings }
